<template>
  <div
    class="workers-list"
    :class="{
      'workers-list--shifting': shifting,
    }"
  >
    <Loader v-if="loadingBack" :active="loadingBack" height="fixed" label="Загрузка сотрудников" />
    <div v-if="loadingBack" class="workers-list-message">
      <div class="workers-list-message__panel workers-list__loader"></div>
    </div>

    <div class="workers-list-shifting-container">
      <div class="workers-list__loader">
        <Loader :active="true" label="Загрузка периодов" />
      </div>
    </div>

    <position-watcher
      ref="positionWatcher"
      v-model="position"
      class="workers-list__items"
      @bottomInView="nextPage"
      @topInView="prevPage"
    >
      <WorkerRow
        v-for="w in workersToRender"
        :key="w.id"
        :days="days"
        :worker="w"
        :can-edit="canEdit"
        :show-all="showAll"
        :data-worker="w.id"
      ></WorkerRow>
    </position-watcher>

    <div v-if="inited && !loadingForward && !loadingBack && empty && lastRequestEmpty" class="workers-list-message">
      <div class="workers-list-message__panel workers-list__empty">
        За текущий период отпуска и больничные не найдены
      </div>
    </div>

    <div v-if="loadingForward" class="workers-list-message">
      <div class="workers-list-message__panel workers-list__loader">
        <Loader :active="true" height="fixed" label="Загрузка сотрудников" />
      </div>
    </div>
  </div>
</template>

<script>
import WorkerRow from "../worker-row";
import PositionWatcher from "@/components/position-watcher";
import Loader from "@/components/loader";
import { Delay } from "@/utils/timer/delay";

const REPORTS_PER_PAGE = 30;
const MAX_PAGES_COUNT = 2;

export default {
  name: "worker-list",
  components: { WorkerRow, PositionWatcher, Loader },
  props: ["days", "canEdit", "showAll", "frame"],
  data() {
    return {
      workers: [],
      from: 0,
      filters: {},
      lastRequestEmpty: false,
      loadingBack: false,
      loadingForward: false,
      shifting: false,

      position: null,
      inited: false,
      workersStartIndex: 0,
      workersEndIndex: 59,
    };
  },

  computed: {
    empty() {
      return !this.workers.some((w) => w.vacations.length);
    },
    workersToRender() {
      return this.workers.slice(this.workersStartIndex, this.workersEndIndex + 1);
    },
  },

  methods: {
    shouldScrollToWorker() {
      if (this._lastWorkerToScroll) {
        const worker = this.$el.querySelector(`[data-worker="${this._lastWorkerToScroll}"]`);
        this._lastWorkerToScroll = null;
        if (worker) {
          worker.scrollIntoView(false);
          setTimeout(() => {
            this.immitateScroll(worker);
          }, 0);
        }

        return;
      }
      if (this._firstWorkerToScroll) {
        if (this.workersStartIndex === 0) {
          this._firstWorkerToScroll = null;
          return;
        }
        const worker = this.$el.querySelector(`[data-worker="${this._firstWorkerToScroll}"]`);

        this._firstWorkerToScroll = null;
        if (worker) {
          worker.scrollIntoView(true);
          setTimeout(() => {
            this.immitateScroll(worker);
          }, 0);
        }
      }
    },
    immitateScroll(element) {
      const layout = document.querySelector(".layout");
      layout.scrollTo(0, element.offsetTop + 50);
    },
    // подгрузка новых сотрудников
    loadWorkers(params) {
      if (this.frame) {
        delete params.from;
        delete params.to;
        params.all = 1;
      }

      return this.$store.dispatch("vacationsChart/getData", params);
    },

    loadWorkersBack() {
      this.loadingBack = true;

      if (this.workersStartIndex > 0) {
        this._firstWorkerToScroll = this.workers[this.workersStartIndex].id;
        this.workersStartIndex -= 30;
      }
      if (this.workersEndIndex > 59) {
        this.workersEndIndex -= 30;
      }

      this.shouldScrollToWorker();

      setTimeout(() => {
        this.loadingBack = false;
      }, 500);
    },

    loadWorkersForward() {
      this.loadingForward = true;

      if (this.from !== this.workersStartIndex) {
        this._lastWorkerToScroll = this.workers[this.workersEndIndex].id;
        this.workersStartIndex += 30;
        this.workersEndIndex += 30;

        this.shouldScrollToWorker();
        setTimeout(() => {
          this.loadingForward = false;
        }, 500);

        return new Promise((resolve) => {
          resolve();
        });
      }

      const params = {
        ...this.filters,
        from: this.from + this.workersToRender.length + 1,
        to: this.from + this.workersToRender.length + REPORTS_PER_PAGE,
      };

      return this.loadWorkers(params).then((workers) => {
        if (!workers.length) this.lastRequestEmpty = true;

        const newWorkers = [...this.workers, ...workers];

        const maxCount = REPORTS_PER_PAGE * MAX_PAGES_COUNT;
        const count = newWorkers.length;

        if (count > maxCount) {
          this.workersStartIndex += 30;
          this.workersEndIndex += 30;
          this.from += 30;
        }

        if (workers.length && this.workers.length) {
          this._lastWorkerToScroll = this.workers[this.workers.length - 1].id;
        }

        this.workers = newWorkers;

        this.loadingForward = false;

        this.shouldScrollToWorker();
      });
    },

    update(filters) { 
      this.loading = false;
      this.lastRequestEmpty = false;
      this.filters = filters;
      this.from = 0;
      this.workers = [];
      this._firstWorkerToScroll = null;
      this._lastWorkerToScroll = null;
      this.loadWorkersForward().then(() => {
        this.inited = true;
      });
    },

    nextPage() { 
      if (this.frame) return;
      if (!this.inited) return;
      if (this.lastRequestEmpty) return;
      if (this.loadingForward) return;
      this.loadWorkersForward();
    },

    prevPage() { 
      if (!this.inited) return;
      if (this.from === 0) return;
      if (this.loadingBack) return;
      this.loadWorkersBack();
    },

    // обновление периодов
    shiftForward(params) {
      this.shiftPeriods(params, "forward");
    },
    shiftBack(params) {
      this.shiftPeriods(params, "back");
    },

    shiftPeriods(addParams, shiftType) {
      this.shifting = true;
      const delay = Delay(1000);
      const params = {
        ...this.filters,
        ...addParams,
        from: this.from + 1,
        to: this.from + this.workers.length,
      };

      return this.$store.dispatch("vacationsChart/getData", params).then((data) => {
        this.workers = this.workers.map((worker) => {
          const workerData = data.find((w) => w.id === worker.id);
          if (!workerData) return worker;

          const newPeriods = workerData.vacations
            .map((period) => {
              if (worker.vacations.some((p) => p.id === period.id)) return null;
              return period;
            })
            .filter(Boolean);

          if (shiftType === "back") {
            worker.vacations = [...newPeriods, ...worker.vacations];
          } else {
            worker.vacations = [...worker.vacations, ...newPeriods];
          }

          return worker;
        });
        delay.then(() => {
          this.shifting = false;
        });
      });
    },
    removePeriodsBefore() {
      this.workers = this.workers.map((worker) => {
        const vacations = worker.vacations.filter(() => true);

        return {
          ...worker,
          vacations,
        };
      });
    },
    removePeriodsAfter() {},
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.workers-list {
  position: relative;
  &-shifting-container {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .workers-list__loader {
      position: sticky !important;
      left: 0;
      width: calc(100vw - 260px);
      height: 100%;
      z-index: 22;
      background: rgba(255, 255, 255, 0.5);

      .loader {
        height: 70px;
        max-height: 100%;

        .loader-overlay {
          background: transparent;
          border: none;
        }
      }
    }
  }
  &--shifting {
    .workers-list-shifting-container {
      display: flex;
    }
  }
  &-message {
    &__panel {
      position: sticky !important;
      left: 0;
      width: calc(100vw - 260px);
      z-index: 22;
      background: white;
    }

    @media screen and (max-width: 992px) {
      &__panel {
        width: calc(100vw - 60px) !important;
      }
    }

    @media screen and (max-width: 767px) {
      &__panel {
        width: 100vw !important;
      }
    }
  }

  &__empty {
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 15px;
    color: $color-label;
    border: 1px solid #dfe4ef;
    margin: -3px 0 -1px;
    line-height: 1.3;
    padding-top: 5px;
    padding-bottom: 5px;

    @include onlyStandartMobile {
      text-align: center;
      height: auto;
      min-height: 40px;
    }
  }

  &__loader {
    margin: -3px 0 -1px;
    .loader {
      .loader-icon {
        margin: 0;
      }
    }
  }
}

.app__layout_sidebar-collapsed {
  .workers-list {
    &-message {
      &__panel {
        width: calc(100vw - 120px);
      }
    }
  }
}
</style>
